import React from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import KeywordSearch from "../../../sharedComponents/keywordSearch";
import { Dropdown } from "react-bootstrap";
import { searchWorkoutPlan } from "../../../store/actions";
import { sortItemList } from "../../../constants/workoutPlanConstants";
import Tooltip from "../../../sharedComponents/tooltip";

const WorkoutPlanHeader = ({ empty, searchWorkoutPlan, sortBy }) => {
	const setSortNav = (navItem) => {
		sortItemList.map((item) => {
			const sort = item === navItem ? (item.sort === "-asc" ? "-desc" : item.sort === "-desc" ? "-asc" : "-asc") : "";
			return (item.sort = sort);
		});
		const { field, sort, sortReverse } = sortItemList.filter((item) => {
			return item.sort === "-asc" || item.sort === "-desc";
		})[0];
		const queryString = sortReverse ? `${sort === "-desc" ? "" : "-"}${field}` : `${sort === "-desc" ? "-" : ""}${field}`;
		sortBy(queryString);
	};

	return (
		<div className="table-header">
			<div className="d-flex flex-row mb-3">
				<h3 className="flex-fill m-0"> Recommended</h3>
				<KeywordSearch
					placeholder="Search Plans"
					searchField="search"
					searchAction={searchWorkoutPlan}
					name="searchWorkoutPlan"
				/>
				{!empty ? <Tooltip content="Sort">
					<Dropdown drop="down" className="sort-recipe-dropdown ml-3">
						<Dropdown.Toggle className="btn btn-primary-dark btn-ghost btn-icon">
							<i className="icon icon-transit" />
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<ul className="sort-nav-list">
								{sortItemList.map((item, index) => {
									return (
										<li key={index} className="sort-nav" onClick={() => setSortNav(item)}>
											<i className={`icon icon-sort${item.sort}`} />
											{item.name}
										</li>
									);
								})}
							</ul>
						</Dropdown.Menu>
					</Dropdown>
				</Tooltip> : null}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { WorkoutPlans } = state;
	return { workoutPlanSearchResult: get(WorkoutPlans, "searchWorkoutPlanList.results", []) };
};

const mapDispatchToProps = { searchWorkoutPlan };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(WorkoutPlanHeader);
